var Location = {
  pathname: function pathname() {
    return window.location.pathname;
  },
  reload: function reload() {
    return window.location.reload();
  },
  redirect: function redirect(url) {
    window.location.replace(url);
  },
  redirectWithReturnUrl: function redirectWithReturnUrl(url) {
    window.location.replace(url + (window.location.pathname ? "?ReturnUrl=".concat(window.location.pathname) : ''));
  }
};
export default Location;